export default function ExploreBooks() {
  const classes = [
    "Nursery",
    "LKG",
    "UKG",
    "Class 1",
    "Class 2",
    "Class 3",
    "Class 4",
    "Class 5",
  ];

  return (
    <div className="min-h-screen bg-[#FFF9F4] p-10">
      <h1 className="text-5xl font-bold text-center mb-16">
        🌈 Choose Your Learning Journey
      </h1>

      <div className="grid md:grid-cols-4 gap-8">
        {classes.map((item, index) => (
          <div
            key={index}
            className="
bg-white
rounded-3xl
p-10
shadow-xl
cursor-pointer
hover:-translate-y-3
hover:scale-105
transition-all
duration-300
"
          >
            <div className="text-6xl text-center">📚</div>

            <h2 className="text-2xl font-bold text-center mt-5">{item}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}
